import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountService } from '../../services';
import { AddonsIdentifiersEnum } from '../../enums';

@Pipe({
    name: 'hasPlans',
    standalone: false
})
export class HasPlansPipe implements PipeTransform {
    constructor(private readonly accountService: AccountService) {
    }
    transform(identifiers: AddonsIdentifiersEnum[], every?: boolean): Observable<boolean> {
        return this.accountService.hasPlansAsync(identifiers, every);
    }
}
